import { jsx as _jsx } from 'react/jsx-runtime.js';
import { FlexColumn, FlexGrid } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../redux/hooks.js';
import { isAppleEnabledSelector, isFacebookEnabledSelector, isGoogleEnabledSelector, } from '../../redux/core/siteConfig/siteConfigSlice.js';
import { useOptimizelyExperiment } from '../../redux/core/experiments/useOptimizelyExperiment.js';
import { AppleButton } from '../../redux/features/loginWithApple/index.js';
import { GoogleButton } from '../../redux/features/google/GoogleButton/index.js';
import { FacebookButton } from '../../redux/features/facebook/FacebookButton/index.js';
import { LinkedInButton } from '../../redux/features/loginWithLinkedIn/index.js';
import { LinkedInCEExceptDELoginExperimentKey, LinkedInDELoginExperimentKey, LinkedInUKLoginExperimentKey, } from '../../redux/core/experiments/allExperiments/linkedInLogin.js';
import { isAppleDevice } from '../../helpers/deviceDetection.js';
export const SocialsWrapperDynamic = () => {
    const { t } = useTranslation();
    const linkedInDELoginExperimentVariant = useOptimizelyExperiment(LinkedInDELoginExperimentKey);
    const linkedInCEExceptDELoginExperimentVariant = useOptimizelyExperiment(LinkedInCEExceptDELoginExperimentKey);
    const linkedInUKLoginExperimentVariant = useOptimizelyExperiment(LinkedInUKLoginExperimentKey);
    const shouldShowAppleButton = useAppSelector(isAppleEnabledSelector);
    const shouldShowGoogleButton = useAppSelector(isGoogleEnabledSelector);
    const shouldShowFacebookButton = useAppSelector(isFacebookEnabledSelector);
    const shouldShowLinkedInButton = linkedInDELoginExperimentVariant === 'B' ||
        linkedInCEExceptDELoginExperimentVariant === 'B' ||
        linkedInUKLoginExperimentVariant === 'B';
    const googleButton = shouldShowGoogleButton && (_jsx(GoogleButton, { buttonText: t('loginregistration.twoStepLoginRegistration.socialButtons.google') }, 'google'));
    const appleButton = shouldShowAppleButton && _jsx(AppleButton, {}, 'apple');
    const linkedInButton = shouldShowLinkedInButton && (_jsx(LinkedInButton, {}, 'linkedin'));
    const facebookButton = shouldShowFacebookButton && (_jsx(FacebookButton, { buttonText: t('loginregistration.twoStepLoginRegistration.socialButtons.facebook') }, 'facebook'));
    const children = isAppleDevice()
        ? [googleButton, appleButton, linkedInButton, facebookButton]
        : [googleButton, linkedInButton, facebookButton, appleButton];
    const MIN_BUTTON_WIDTH = 156;
    const calculateSpan = (count) => {
        const arr = [[12], [12, 12, 6, 6], [12, 12, 12, 4], [12, 12, 6, 6]];
        return arr?.[count - 1] || [12];
    };
    const verifiedChildren = children.filter((child) => !!child);
    const count = verifiedChildren.length;
    return (_jsx(FlexGrid, { gutter: 'spaceM', flxDirection: ['column', 'row'], children: verifiedChildren.map((child) => (_jsx(FlexColumn, { span: calculateSpan(count), sx: { minWidth: `${MIN_BUTTON_WIDTH}px` }, children: child }, child.key))) }));
};
//# sourceMappingURL=SocialsWrapperDynamic.js.map